// extracted by mini-css-extract-plugin
export default {"infinitheism":"HighlightMahatriaInfinitheism_infinitheism__Xtb3S","mahatria":"HighlightMahatriaInfinitheism_mahatria__XYWmY"};